import moment from 'moment'
import { DrillDownEvent } from "../types"

export const calcIntervalDistance = (events: DrillDownEvent[]) => {
    let start = 0
    let end = 0
    let acumulate = 0
    const interval: any[] = []

    if (events === null) {
        throw 'Can not calc interval'
    }

    events.forEach((marker, index: number) => {
        let { distance = 0 } = marker

        if (index === 0) {
            distance = 0
        }

        acumulate += distance

        if (index > 0) {
            end = acumulate
            interval.push({ start, end, marker })
            start = end
        }
    })

    return interval
}

export const calcTravelledDistance = (events: {distance:number}[]) => {
    if (events && events.length > 0) { 
        let acumulate = 0

        events.forEach(({ distance = 0 }, index) => {
            if (index === 0) {
                distance = 0
            }

            acumulate += distance
        })

        return acumulate
    }

    return 0
}

export const calcAccumulateTime = (events) => {
    if (events == null || events.length === 0) {
      return '0d'; 
    }
  
    let totalDuration = moment.duration();
  
    for (let i = 1; i < events.length; i++) {
      const eventTime = moment(events[i].timestamp);
      const prevEventTime = moment(events[i - 1].timestamp);
      const duration = moment.duration(eventTime.diff(prevEventTime));
      totalDuration = totalDuration.add(duration);
    }
  
    const days = totalDuration.days();
    const hours = totalDuration.hours();
    const minutes = totalDuration.minutes();
  
    let formattedTime = '';
  
    if (days > 0) {
      formattedTime += `${days}d `;
    }
    if (hours > 0) {
      formattedTime += `${hours}h `;
    }
    if (minutes > 0) {
      formattedTime += `${minutes}m `;
    }
  
    return formattedTime.trim(); 
  };

